module.exports = __webpack_public_path__ + "static/media/yt-daily-life.7fe1ee13.mov";